import { render, staticRenderFns } from "./NetworkWatcher.vue?vue&type=template&id=edb6f5fe&"
import script from "./NetworkWatcher.vue?vue&type=script&lang=js&"
export * from "./NetworkWatcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports